import { render, staticRenderFns } from "./EditReborer.vue?vue&type=template&id=40215afd&scoped=true"
import script from "./EditReborer.vue?vue&type=script&lang=js"
export * from "./EditReborer.vue?vue&type=script&lang=js"
import style0 from "./EditReborer.vue?vue&type=style&index=0&id=40215afd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40215afd",
  null
  
)

export default component.exports